import * as L from 'leaflet';
import stations from './awstirolData';

const AwsTirol = L.FeatureGroup.extend({
  onAdd: function() {
    for (const s of stations) {
      const dome = document.createElement('a');
      dome.innerHTML = 'weather information: ' + s[4];
      dome.href = "https://wiski.tirol.gv.at/lawine/grafiken/540/standard/dreitage/" + s[2];
      dome.target = "_blank";
      const m = new L.Marker([s[1], s[0]], {
        icon: L.divIcon({
          iconSize: [32, 32],
          className: "icon-Temperatur awsIcon mapIcon"
        })
      }).bindPopup(dome);
      this.addLayer(m);
    }
  },
});

export default AwsTirol;
